export default __webpack_public_path__ + "static/flipImg2-d956b4e341a217b445484613c6186e1d.webp";